// extracted by mini-css-extract-plugin
export var chevron = "_j4-2";
export var dropdownItems = "_j4-0";
export var item = "_j4-1";